import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (anchor link), scroll to that element
    if (hash) {
      const elementId = hash.substring(1);
      const scrollToElement = () => {
        const element = document.getElementById(elementId);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offsetTop = window.pageYOffset + rect.top - 100; // 100px offset from top
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      };
      
      // Try immediately and with delays
      scrollToElement();
      setTimeout(scrollToElement, 100);
      setTimeout(scrollToElement, 300);
      setTimeout(scrollToElement, 500);
      return;
    }
    
    // Only scroll to top if there's no hash (regular page navigation)
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
